interface FollowButtonStateInput {
  isFollowed: boolean;
  isExpertFavorite?: boolean;
  hideWhenFollowed?: boolean;
  hasUnfollowHandler?: boolean;
}

export const resolveFollowButtonState = ({
  isFollowed,
  isExpertFavorite,
  hideWhenFollowed = false,
  hasUnfollowHandler = false,
}: FollowButtonStateInput) => {
  const following = Boolean(isFollowed || isExpertFavorite);

  return {
    following,
    shouldHide: hideWhenFollowed && following,
    canUnfollow: following && hasUnfollowHandler,
  };
};
